"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backwardCompatChart = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ChartType_1 = __importDefault(require("../ChartType"));
const ChartVariant_1 = __importDefault(require("../ChartVariant"));
function backwardCompatChart(chart) {
    var _a, _b;
    if (!chart)
        return;
    if (!chart.chartType)
        chart.chartType = chart['type'];
    if (!chart.chartVariant)
        chart.chartVariant = chart['variant'];
    if (((_a = chart === null || chart === void 0 ? void 0 : chart.config) === null || _a === void 0 ? void 0 : _a.dimension) === 'site')
        chart.config.dimension = QueryFieldKey_1.default.PLACE;
    if (((_b = chart === null || chart === void 0 ? void 0 : chart.config) === null || _b === void 0 ? void 0 : _b.otherDimension) === 'site')
        chart.config.otherDimension = QueryFieldKey_1.default.PLACE;
    switch (`${chart.chartType}`) {
        case 'timebar':
            chart.chartType = ChartType_1.default.BAR3DGROUP;
            chart.chartVariant = ChartVariant_1.default.COUNT_GROUP_TIME;
            break;
        case 'timestack':
            chart.chartType = ChartType_1.default.BAR3DSTACK;
            chart.chartVariant = ChartVariant_1.default.COUNT_GROUP_TIME;
            break;
        case 'timearea':
            chart.chartType = ChartType_1.default.AREA3DSTACK;
            chart.chartVariant = ChartVariant_1.default.COUNT_GROUP_TIME;
            break;
        case 'pie':
            chart.chartType = ChartType_1.default.PIE2D;
            chart.chartVariant = ChartVariant_1.default.COUNT_GROUP;
            break;
        case 'bar':
            chart.chartType = ChartType_1.default.BAR2D;
            chart.chartVariant = ChartVariant_1.default.COUNT_GROUP;
            break;
    }
}
exports.backwardCompatChart = backwardCompatChart;
exports.default = backwardCompatChart;
